import React, { useEffect, useState } from "react";
import NavbarHeader from "../../../Navbarheader/NavbarHeader";
import Footer from "../../../Footer/Footer";
import HeroSection from "./components/Herosection";

import Moreintro from "./components/Moreintro";
import Moreintro2 from "./components/Moreintro2";
import Role from "./components/Role";
import Timeline from "./components/Timeline";

import Solution from "./components/solution";


import Bannermockup from "./components/Bannermockup";

import NextProjectButton from "../components/NextProjectButton";

import { useNavigate } from 'react-router-dom';
import Development from "./components/Development";
import Bannermockup2 from "./components/Bannermockup2";
import Bannermockup3 from "./components/Bannermockup3";
import InfoArchitecture from "./components/InfoArchitecture";
import LoginRegVd from "./components/LoginRegVd";
import CreateProject from "./components/CreateProject";
import FreelancerEnd from "./components/FreelancerEnd";
import Conclusion from "./components/Conclusion";
import Interview from "./components/Interview";
// import FlowDiagram from "./components/flowdiagram";



function Buidl() {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);
 const navigate = useNavigate()

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);


  const handleNextProjectClick = () => {
    navigate('/project/lodabranding');
  };



  return (
    <div fluid className="scroll-container">
      <NavbarHeader />
      <div
        style={{
          backgroundColor: "#272A38",
          paddingTop: isSmallScreen ? "6rem" : "0px",
        }}
      >
        <HeroSection />

        <Moreintro />
        <Moreintro2 />
        <Role />
        <Timeline />
        <Development />

        <Bannermockup />
        <Interview />
        <Solution />
        <Bannermockup2 />
        <Bannermockup3 />
        <InfoArchitecture />
        <LoginRegVd />
        <CreateProject />
        <FreelancerEnd />
        




        <div id="showNextButton">
          <Conclusion />
        </div>
      </div>
      <Footer />

      <NextProjectButton 
        sectionId="showNextButton" 
        onClick={handleNextProjectClick} 
      />


    </div>
  );
}

export default Buidl;